import { useSelector } from "react-redux";
import { selectIsPricesBlurred } from "../../redux/auth";

export const withBlur = (WrappedComponent) => {
  const Component = (props) => {
    const isPriceBlurred = useSelector(selectIsPricesBlurred);

    return <WrappedComponent isBlurred={isPriceBlurred} {...props} />;
  };

  return Component;
};
